// 课程推荐列表
const recommendList = () => import('@/pages/arkHome/recommendList.vue');
const recommendClassList = () => import('@/pages/arkHome/recommendClassList.vue');
export default [
  {
    path: '/recommendList',
    name: 'recommendList',
    component: recommendList,
    meta: {
      title: '课程列表',
    },
  },
  {
    path: '/recommendClassList',
    name: 'recommendClassList',
    component: recommendClassList,
    meta: {
      title: '活动列表',
    },
  },
];
